import { Product, Variant } from "../../types/types";

export const isValidSize = (size: string, product: Product) =>
  product.variants.some((v: Variant) => v.differentiators?.size === size);

export const isValidColour = (colour: string, product: Product): boolean =>
  product.variants.some((v: Variant) => v.differentiators?.colour === colour);

export const getVariant = ({
  product,
  userSelectedColour,
  userSelectedSize,
}: {
  product: Product;
  userSelectedColour: string | null;
  userSelectedSize: string | null;
}): Variant | null => {
  const variants: Variant[] = product.variants;

  // 1 user has selected both valid size and colour - return relevant variant
  if (userSelectedColour && userSelectedSize) {
    const variant = variants.find(
      (v) =>
        v.differentiators?.size === userSelectedSize &&
        v.differentiators?.colour === userSelectedColour,
    );

    if (variant) {
      return variant;
    }
  }

  // 2 user has selected a colour - return first variant that matches
  if (userSelectedColour) {
    const variant = variants.find(
      (v) => v.differentiators?.colour === userSelectedColour,
    );

    if (variant) {
      return variant;
    }
  }

  // 3 user has selected a size - return first variant that matches
  if (userSelectedSize) {
    const variant = variants.find(
      (v) => v.differentiators?.size === userSelectedSize,
    );

    if (variant) {
      return variant;
    }
  }

  // 4 an initialVariantId was supplied - return that variant
  if (product.initialVariantId) {
    const variant = variants.find((v) => v.id === product.initialVariantId);

    if (variant) {
      return variant;
    }
  }

  // 5 an initialSkuId was supplied - return that variant
  if (product.initialSkuId) {
    const variant = variants.find(
      (v) => v.aliases?.skuId === product.initialSkuId,
    );

    if (variant) {
      return variant;
    }
  }

  // 6 return default variant or first one in the list
  return (
    variants?.find((v) => v.id === product.defaultVariant.id) ||
    variants[0] ||
    null
  );
};
